import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "@tanstack/react-router"
import { router } from "@/router"
import "@/app/globals.css"
import { PostHogProvider } from "@posthog/react"
import { posthog } from "@/lib/analytics"

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault()

  const lastReload = Number(sessionStorage.getItem("vite-last-reload") || 0)
  const now = Date.now()

  if (now - lastReload > 10000) {
    sessionStorage.setItem("vite-last-reload", String(now))
    window.location.reload()
  }
})

const root = document.getElementById("root")
if (!root) throw new Error("Application root element is missing")

// Show body once React starts rendering
document.body.classList.add("ready")

createRoot(root).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <RouterProvider router={router} />
    </PostHogProvider>
  </StrictMode>,
)
